module.exports = {
    is_production: 1,
    server_url: 'https://sendi.info',
    http_port: 9765,
    ws_port: "https://sendi.info:9767",
    sendi_upload_service_url : 'https://sendi.info:10000/upload',
};
